import { ref } from 'vue'

export const linkGoOrder = ref(false)
